import React, {Component} from 'react';

class Photo extends Component {

    render() {
        if (!(this.props.format.field in this.props.entry.fields)) {
            return null;
        }

        const entry = this.props.entry.fields[this.props.format.field][0];
        const photo = entry.fields[this.props.format.subField];

        if (!photo) {
            return null;
        }

        return (
            <div className="photo-preview" style={{backgroundImage: 'url("'+photo[0].thumbnails.large.url+'")'}}/>
        );
    }
}

export default Photo;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCards/Photo.js